import {LoaderContext} from 'utilities/loaders/types';
import {StatusCode} from '@shopify/network';

import ShopQuery, {ShopQueryData} from './graphql/ShopQuery.graphql';

export async function shopLoader({query, shop: partialShop}: LoaderContext) {
  const {data, error} = await query<ShopQueryData>({
    query: ShopQuery,
  });

  if (error) {
    throw new Response(null, {status: StatusCode.InternalServerError});
  }

  const shop = {
    ...partialShop,
    ...data.shop,
    shopEmail: data.shop.email,
  };

  return {shop};
}
